import * as React from "react";
import {Field} from "react-final-form";
import {EstadosGlosas as estadosGlosas} from "../modelo/EstadosGlosa";

export default class EstadosGlosas extends React.Component<EstadosGlosasProps> {
    render() {
        const {className} = this.props;
        return (
            <Field name={this.props.name}>
                {({input, meta}) => (
                    <div>
                        <select {...input} className={className ? className.concat(" form-control") : "form-control"}>
                            <option value={""}>Selecciona...</option>
                            {estadosGlosas.map(estado => {
                                return <option key={estado} value={estado}>{estado}</option>;
                            })}
                        </select>
                        <div>
                            {meta.error && <span className={"text-danger"}>{meta.error}</span>}
                        </div>
                    </div>
                )}
            </Field>
        );
    }
}

interface EstadosGlosasProps {
    name: string,
    className?: string
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/inconsistencias/componentes/EstadosGlosas.tsx